import { render, staticRenderFns } from "./AllWin.vue?vue&type=template&id=a5572548&scoped=true"
import script from "./AllWin.vue?vue&type=script&lang=js"
export * from "./AllWin.vue?vue&type=script&lang=js"
import style0 from "./AllWin.vue?vue&type=style&index=0&id=a5572548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5572548",
  null
  
)

export default component.exports